module.exports = __webpack_public_path__ + "static/img/2bac.4b38379.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/2bac.jpg
// module id = 3n0v
// module chunks = 1